module.exports = ".user-profile{\r\n    background-color: #CCC;\r\n    width: 1000px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-profile/user-profile.component.css
// module id = ./src/app/user-profile/user-profile.component.css
// module chunks = main